<h2 mat-dialog-title>Configuración Rutero</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col s12 m6 l4" *ngIf="loadingTiposRutero">
      <mat-spinner [diameter]="40" style="top:15px;"></mat-spinner>
    </div>
    <div class="col s12 m6 l4" *ngIf="!loadingTiposRutero">
      <form [formGroup]="configuracionForm">
        <mat-form-field>
          <mat-label>TIPO RUTERO</mat-label>
          <mat-select formControlName="tipoRutero" (selectionChange)="setTipoRutero();">
            <mat-option
              *ngFor="let tipoRutero of tiposRutero"
              [value]="tipoRutero.id"
            >
              {{ tipoRutero.valor }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    <form [formGroup]="frecuenciaForm">
      <div class="col s12 m6 l6" *ngIf="loadingTiposFrecuencia">
        <mat-spinner [diameter]="40" style="top:15px;"></mat-spinner>
      </div>

      <span *ngIf="!loadingTiposFrecuencia">
        <div class="col s12 m6 l6" *ngIf="tipoRuteroVal == 2">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="fechaFrecuencia"
              placeholder="SELECCIONE UNA FECHA"
              (dateChange)="selectFecha($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div
          class="col s12 m12 l12"
          *ngIf="loadingTiposFrecuencia && tipoRuteroVal == 1"
        >
          <mat-spinner [diameter]="40" style="top:15px;"></mat-spinner>
        </div>

        <div class="col s12 m6 l6" *ngIf="!loadingTiposFrecuencia && tipoRuteroVal == 1">
          <mat-form-field>
            <mat-label>FRECUENCIA VISITA</mat-label>
            <mat-select formControlName="tipoFrecuencia" multiple>
              <mat-option
                *ngFor="let frecuencia of frecuencias"
                [value]="frecuencia.id"
                (onSelectionChange)="selectFrecuencia($event)"
              >
                {{ frecuencia.valor }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </span>
    </form>
  </div>

  <div class="row" *ngIf="tipoRuteroVal == 1">
    <div class="col s6 m6 l6" *ngIf="frecuenciaSeleccionada.length > 0">
      <mat-selection-list (selectionChange)="handleSelection($event)">
        <mat-list-option
          *ngFor="let frecuencia of frecuenciaSeleccionada | orderBy: order"
          [value]="frecuencia.id"
        >
          {{ frecuencia.valor }}
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="col s6 m6 l6" *ngIf="mostrarDias">
            <form [formGroup]="diasForm">
        <mat-selection-list
              formControlName="diasVisita"
              (selectionChange)="setDiasFrecuencia()"
            >
              <mat-list-option
                [selected]="dia.checked"
                *ngFor="let dia of diasSemana"
                [value]="dia.id"
              >
                {{ dia.valor }}
              </mat-list-option>
        </mat-selection-list>
    </form>  
    </div> 
       
  </div>
  <div class="row" *ngIf="editandoRuteroSucursal">
        <div class="col s12 m12 l12">
          <mat-spinner [diameter]="40" style="margin:0 auto; top:15px;"></mat-spinner>
        </div>
      </div>

     
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button *ngIf="origen=='editar'" mat-raised-button color="accent" (click)="editarRuteroSucursal()">Editar</button>
    <button *ngIf="origen=='crear'" mat-raised-button color="accent" (click)="crearRuteroSucursal()">Crear</button>
  
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="dataModified"
    cdkFocusInitial
  >
    Cancelar
  </button>
</mat-dialog-actions>
